import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "phoneAbnormal" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getListData } from '@/service/main/system'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'WatchLiveNotDeal',
  setup(__props) {

initEmptyParam()
const store = useStore()
const queryParam = {
  sysDate: dayjs().startOf('date').format('YYYY-MM-DD')
}
store.commit('system/changeQueyryInfo', queryParam)
const resetCb = () => {
  return queryParam
}
//定义筛选规则
const filterRules = [
  '筛选规则：',
  '1、每天早上4点一刻，记录近30天内累计访问直播间超过10次的未成交客户。',
  '2、每天早上7点一刻，生成业务员的近30天内累计访问直播间超过10次的未成交客户通知。'
]
const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "watchLiveNotDeal",
      pageUrl: "/watchLiveNotDeal/queryByCondition",
      downUrl: "/watchLiveNotDeal/download",
      filterRules: filterRules,
      downFilename: "近30天累计听课大于10天的未成交客户企业业务员信息.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick)
    }, {
      sysDate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row?.sysDate ? _unref(dayjs)(scope.row?.sysDate).format('YYYY-MM-DD HH:mm:ss') :'--'), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})